const AccessUv = () => import('@/views/main/promotion/accessUv/AccessUv.vue')
export default {
  path: '/main/promotion/accessUv',
  name: 'AccessUv',
  component: AccessUv,
  children: []
}
